import { render, staticRenderFns } from "./noNavFoolist.vue?vue&type=template&id=68be5f3e"
import script from "./noNavFoolist.vue?vue&type=script&lang=js"
export * from "./noNavFoolist.vue?vue&type=script&lang=js"
import style0 from "./noNavFoolist.vue?vue&type=style&index=0&id=68be5f3e&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68be5f3e')) {
      api.createRecord('68be5f3e', component.options)
    } else {
      api.reload('68be5f3e', component.options)
    }
    module.hot.accept("./noNavFoolist.vue?vue&type=template&id=68be5f3e", function () {
      api.rerender('68be5f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/news/noNavFoolist.vue"
export default component.exports